// 路由守卫实现
import store from "@/store";
import router from "@/router/index";

const WHITE_LIST = ['/login']

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    const hasRoutes = store.state.hasRoutes
    const menuList = JSON.parse(localStorage.getItem('menuList') || '[]')

    if (!token) {
        if (WHITE_LIST.includes(to.path)) {
            next()
        } else {
            next({ path: '/login', query: { redirect: to.fullPath } })
        }
        return
    }

    const currentUser = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const isAdmin = currentUser.roles?.includes('admin') || currentUser.roles?.includes('超级管理员')
    if (to.path === '/sys/doctor' && !isAdmin) {
        next('/index')
        return
    }

    if (!hasRoutes) {
        bindRoute(menuList)
        store.commit('SET_ROUTES_STATE', true)
        next({ ...to, replace: true })
        return
    }

    if (to.path === '/login') {
        next('/index')
        return
    }

    next()
})

// 动态绑定路由
const bindRoute = (menuList) => {
    const newRoutes = router.options.routes
    menuList.forEach(menu => {
        if (menu.children) {
            menu.children.forEach(m => {
                const route = menuToRoute(m, menu.name)
                if (route) {
                    newRoutes[0].children.push(route)
                }
            })
        }
    })
    newRoutes.forEach(route => {
        router.addRoute(route)
    })
}

// 菜单转成路由
const menuToRoute = (menu, parentName) => {
    if (!menu.component) {
        return null
    }
    const route = {
        name: menu.name,
        path: menu.path,
        meta: {
            parentName: parentName
        }
    }
    route.component = () => import('@/views/' + menu.component + '.vue')
    return route
}

const token = localStorage.getItem('token')
const menuList = JSON.parse(localStorage.getItem('menuList') || '[]')
if (token) {
    bindRoute(menuList)
}
